var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",class:_vm.$props.index <= _vm.$props.rating ? 'filled' : 'star',attrs:{"title":"star"}},[_c('use',{attrs:{"xlink:href":_vm.$props.index <= _vm.$props.rating ? '#icon-filledStar' : '#icon-star'}})])}
var staticRenderFns = []

export { render, staticRenderFns }